"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Sparkles, Droplet, Search, Lock, CalendarCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const maintenanceTips = [{
  icon: Sparkles,
  title: "Audio HD y Video 1080p",
  description: "Comunicaciones cristalinas con cancelación de ruido activa y soporte para video de alta definición en todas las terminales."
}, {
  icon: Droplet,
  title: "Integración de API Fluida",
  description: "Conecte su infraestructura de voz con CRMs y herramientas de productividad mediante nuestras robustas interfaces de programación."
}, {
  icon: Search,
  title: "Gestión de Colas e IVR",
  description: "Sistemas de respuesta interactiva inteligentes y colas de llamadas dinámicas para optimizar el flujo de atención al cliente."
}, {
  icon: Lock,
  title: "Seguridad y Endpoints SIP",
  description: "Protocolos de cifrado avanzados compatibles con softphones, terminales SIP y accesorios Bluetooth/USB profesionales."
}];
export default function TechnicalCapabilities() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="258071" id="technical-capabilities" className="py-10 md:py-14 bg-background text-foreground">
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          
          {/* Columna Izquierda: Información */}
          <div ref={leftRef} className={`flex flex-col items-start gap-6 transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <span className="text-sm font-bold tracking-wider text-primary uppercase font-default">
              Infraestructura de Voz de Próxima Generación
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-default text-foreground leading-tight font-bold">
              Capacidades Técnicas de Alto Rendimiento
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed font-default">
              Nuestra plataforma está diseñada para empresas que exigen fiabilidad técnica. Desde la integración con MS Teams hasta el soporte de hardware especializado, cubrimos cada aspecto de su ecosistema de comunicaciones.
            </p>
            <Button asChild size="lg" className="mt-4 bg-primary hover:bg-secondary text-primary-foreground rounded-md shadow-md transition-colors">
              <Link to="/MsTeamsIntegrationPage">
                <CalendarCheck className="mr-2 size-5" />
                Ver Especificaciones Técnicas
              </Link>
            </Button>
          </div>

          {/* Columna Derecha: Tarjetas de Capacidades */}
          <div ref={rightRef} className={`flex flex-col gap-8 transition-all duration-700 delay-200 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {maintenanceTips.map((tip, i) => <div key={i} data-index={i} className="flex gap-4 md:gap-6">
                <div className="shrink-0 flex items-center justify-center size-12 rounded-md bg-accent border border-border text-primary shadow-sm">
                  <tip.icon className="size-5" />
                </div>
                <div className="flex flex-col gap-1.5">
                  <h3 className="text-xl font-default font-semibold text-foreground">
                    {tip.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed font-default">
                    {tip.description}
                  </p>
                </div>
              </div>)}
          </div>

        </div>
      </div>
    </section>;
}